import type {
  RequestCreateUserType,
  RequestUpdateUserType,
} from 'b2b-apps/shop/myAccount/users/api/User.types';
import {
  ClearAccountUserAction,
  CreateUserAction,
  CreateUserCallbackType,
  FetchUserAction,
  FetchUserFulfilledAction,
  FetchUserRejectedAction,
  RemoveUserAction,
  RemoveUserCallbackType,
  UpdateUserAction,
  UpdateUserCallbackType,
  UserType,
} from 'b2b-common/core/account/api/User.types';
import {
  CLEAR_ACCOUNT_USER,
  CREATE_USER,
  FETCH_USER,
  FETCH_USER_FULFILLED,
  FETCH_USER_REJECTED,
  REMOVE_USER,
  UPDATE_USER,
} from './actionTypes';

const createUser = (
  data: RequestCreateUserType,
  callback: CreateUserCallbackType,
): CreateUserAction => ({
  type: CREATE_USER,
  payload: {
    data,
    callback,
  },
});

const fetchUser = (accountId: string): FetchUserAction => ({
  type: FETCH_USER,
  payload: {
    accountId,
  },
});

const fetchUserFulfilled = (
  accountId: string,
  response: UserType,
): FetchUserFulfilledAction => ({
  type: FETCH_USER_FULFILLED,
  payload: {
    accountId,
    data: response,
  },
});

const fetchUserRejected = (
  accountId: string,
  error: ErrorType,
): FetchUserRejectedAction => ({
  type: FETCH_USER_REJECTED,
  payload: {
    accountId,
    error,
  },
});

const updateUser = (
  accountId: string,
  data: RequestUpdateUserType,
  callback: UpdateUserCallbackType,
): UpdateUserAction => ({
  type: UPDATE_USER,
  payload: {
    accountId,
    data,
    callback,
  },
});

const removeUser = (
  accountId: string,
  callback: RemoveUserCallbackType,
): RemoveUserAction => ({
  type: REMOVE_USER,
  payload: {
    accountId,
    callback,
  },
});

const clearAccountUser = (): ClearAccountUserAction => ({
  type: CLEAR_ACCOUNT_USER,
});

export {
  clearAccountUser,
  createUser,
  fetchUser,
  fetchUserFulfilled,
  fetchUserRejected,
  removeUser,
  updateUser,
};
